import React, { useState, useEffect, useContext } from "react";
import "./History.css";
import { Breadcrumb, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import Purchased_Items_Modal from "../../../Common_modal/Purchased_Items_Modal/Purchased_Items_Modal";
import Return_Items_Modal from "../../../Common_modal/Purchased_Items_Modal/PurchasedItemReturnModal";
import { Context } from "../../../../utils/context";
import { orderGet } from "../../../../utils/apis/myAccount/myAccount";
import CustomPagination from "../../../Common_modal/CustomPagination";
function History() {
  const [modalShow, setModalShow] = React.useState(false);
  const [modalShowReturn, setModalShowReturn] = React.useState(false);
  const [modalShowOne, setModalShowTwo] = React.useState(false);

  const { IMG_URL } = useContext(Context);

  const [data, setData] = useState();

  const [orders, setOrder] = useState([]);

  console.log(orders, "orders");

  const getOrders = async () => {
    const res = await orderGet(currentPage);
    if (res?.success) {
      setOrder(res?.data);
    }
  };

  useEffect(() => {
    getOrders();
  }, []);

  const handleDownload = async (invoice) => {
    try {
      // const response = await getData(`/order/invoice-download/${id}`);

      const filePath = invoice;

      if (!filePath) {
        console.error("File path is undefined or null");
        return;
      }

      const url = `${IMG_URL}/${filePath}`;

      const a = document.createElement("a");
      a.href = url;
      a.target = "_blank";
      a.rel = "noopener noreferrer";
      a.click();
    } catch (error) {
      console.error("Error opening file:", error);
    }
  };

  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    getOrders();
  }, [currentPage]);

  return (
    <>
      <section className="my-account  my-account-main checkout-inner-steps ">
        <div className="container-fluid">
          <div className="account-table confirm_order Product_Cart">
            <div className="heading_holder">
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Link to={"/"}>Home</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                  <Link to={"/information"}>Information</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item active>
                  <Link to={"/order-history"}>Order history</Link>
                </Breadcrumb.Item>
              </Breadcrumb>
            </div>

            <div className="back-text-holder">
              <Link to={"/information"}>
                <p>Back</p>
              </Link>
            </div>

            <div className="product_table">
              <Table responsive bordered>
                <thead>
                  <tr>
                    <th>S. No.</th>
                    <th>Order ID.</th>
                    <th>Order Date</th>
                    {/* <th>Delivery Date</th> */}
                    <th>Total</th>
                    <th>Payment Type</th>
                    {/* <th>Payment Status</th> */}
                    <th>Order Quantity</th>
                    <th>Order Progress</th>
                    <th>Download Invoice</th>
                  </tr>
                </thead>
                <tbody>
                  {orders?.data?.map((value, index) => {
                    const items = value?.order_items || [];
                    const rowSpan = items.length || 1;

                    return items.map((item, itemIndex) => (
                      <tr key={`${index}-${itemIndex}`}>
                        {/* S. No. */}
                        {itemIndex === 0 && (
                          <td rowSpan={rowSpan}>
                            {(currentPage - 1) * 10 + index + 1}
                          </td>
                        )}

                        {/* Order No */}
                        {itemIndex === 0 && (
                          <td rowSpan={rowSpan}>
                            {value?.order?.invoice_number}
                          </td>
                        )}

                        {/* Order Date */}
                        {itemIndex === 0 && (
                          <td rowSpan={rowSpan}>
                            {value?.order?.createdAt?.split("T")[0]}
                          </td>
                        )}

                        {/* Total */}
                        {itemIndex === 0 && (
                          <td rowSpan={rowSpan}>₹ {value?.order?.amount}</td>
                        )}

                        {/* Payment Type */}
                        {itemIndex === 0 && (
                          <td rowSpan={rowSpan}>
                            {value?.order?.payment_mode === "cod"
                              ? "COD"
                              : "Online"}
                          </td>
                        )}

                        {/* Payment Status (ITEM-WISE) */}
                        {/* <td className="green-text">
                          {item?.payment_status || item?.status}
                        </td> */}

                        {/* Quantity (ITEM-WISE) */}
                        <td>{item?.quantity}</td>

                        {/* Order Progress (ITEM-WISE VIEW) */}

                        <td
                          className="view-text"
                          onClick={() => {
                            setData(item);
                            setModalShow(true);
                          }}>
                          <button className="viewbtttt">View</button>
                        </td>

                        {/* Download Invoice (MERGED) */}
                        {itemIndex === 0 && (
                          <td rowSpan={rowSpan}>
                            <div className="d-flex">
                              <button
                                onClick={() =>
                                  handleDownload(value?.order?.invoice)
                                }
                                className="btn btn-primary">
                                Download
                              </button>
                            </div>
                          </td>
                        )}
                      </tr>
                    ));
                  })}
                </tbody>
              </Table>

              <div className="span-holder"></div>
            </div>

            {/* <div className="paginationss">
              <CustomPagination
                currentPage={currentPage}
                totalPages={orders?.totalPages}
                handlePageChange={handlePageChange}
              />
            </div> */}
          </div>
        </div>
      </section>

      <Purchased_Items_Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        data={data}
      />
      <Return_Items_Modal
        show={modalShowReturn}
        onHide={() => setModalShowReturn(false)}
        data={data}
      />
    </>
  );
}

export default History;
